import { FiltroLista, IFiltroLista } from 'src/app/filter/filtro-lista';


export interface IFiltroListaDDA extends IFiltroLista{

  CFIGFORNEC: string;
  CFIGLOJA: string;
  CFIGFORNECELOJA: string;
  CFIGTITULO: string;
  CFIGTIPO: string;
  CFIGDDASE2: string;
  CFIGCONCIL: string;
  DFIGDATA_DE: Date | undefined;
  DFIGDATA_ATE: Date | undefined;
  DFIGVENCTO_DE: Date | undefined;
  DFIGVENCTO_ATE: Date | undefined;
  DFIGDTCONC_DE: Date | undefined;
  DFIGDTCONC_ATE: Date | undefined;

}

export class FiltroListaDDA extends FiltroLista {

  dados: IFiltroListaDDA = this.setDefault();
  timeout = this.getDataString();

  public setDefault(): IFiltroListaDDA {
    return {
      page: 1,
      pageSize: 20,
      filter: '',
      order: '',

      CFIGTITULO: '',
      CFIGFORNEC: '',
      CFIGLOJA: '',
      CFIGFORNECELOJA: '',
      CFIGTIPO: '',
      CFIGDDASE2: '',
      CFIGCONCIL: ' ',
      DFIGDATA_DE: this.getData(-30),
      DFIGDATA_ATE: this.getData(),
      DFIGVENCTO_DE: undefined,
      DFIGVENCTO_ATE: undefined,
      DFIGDTCONC_DE: undefined,
      DFIGDTCONC_ATE: undefined,
    };
  }

}
